/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Partner information returned to the UI
 * @export
 * @interface PartnerSearchByBrResponse
 */
export interface PartnerSearchByBrResponse {
    /**
     * Global partner ID
     * @type {string}
     * @memberof PartnerSearchByBrResponse
     */
    globalPartnerId?: string;
    /**
     * Technical UUID of the partner
     * @type {string}
     * @memberof PartnerSearchByBrResponse
     */
    techId?: string;
    /**
     * Partner type
     * @type {string}
     * @memberof PartnerSearchByBrResponse
     */
    partnerType?: string;
    /**
     * Whether imported from another system
     * @type {boolean}
     * @memberof PartnerSearchByBrResponse
     */
    imported?: boolean;
    /**
     * Main domicile country
     * @type {string}
     * @memberof PartnerSearchByBrResponse
     */
    mainDomicileCountry?: string;
    /**
     * Full name
     * @type {string}
     * @memberof PartnerSearchByBrResponse
     */
    fullName?: string;
    /**
     * Date of origin
     * @type {Date}
     * @memberof PartnerSearchByBrResponse
     */
    dateOfOrigin?: Date;
    /**
     * Last eBanking login timestamp
     * @type {Date}
     * @memberof PartnerSearchByBrResponse
     */
    lastLogin?: Date | null;
    /**
     * Whether the partner is blocked for eBanking access
     * @type {boolean}
     * @memberof PartnerSearchByBrResponse
     */
    isBlocked?: boolean | null;
    /**
     * eBanking j-number identifier
     * @type {string}
     * @memberof PartnerSearchByBrResponse
     */
    jNr?: string | null;
}

/**
 * Check if a given object implements the PartnerSearchByBrResponse interface.
 */
export function instanceOfPartnerSearchByBrResponse(value: object): value is PartnerSearchByBrResponse {
    return true;
}

export function PartnerSearchByBrResponseFromJSON(json: any): PartnerSearchByBrResponse {
    return PartnerSearchByBrResponseFromJSONTyped(json, false);
}

export function PartnerSearchByBrResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerSearchByBrResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'globalPartnerId': json['globalPartnerId'] == null ? undefined : json['globalPartnerId'],
        'techId': json['techId'] == null ? undefined : json['techId'],
        'partnerType': json['partnerType'] == null ? undefined : json['partnerType'],
        'imported': json['imported'] == null ? undefined : json['imported'],
        'mainDomicileCountry': json['mainDomicileCountry'] == null ? undefined : json['mainDomicileCountry'],
        'fullName': json['fullName'] == null ? undefined : json['fullName'],
        'dateOfOrigin': json['dateOfOrigin'] == null ? undefined : (new Date(json['dateOfOrigin'])),
        'lastLogin': json['lastLogin'] == null ? undefined : (new Date(json['lastLogin'])),
        'isBlocked': json['isBlocked'] == null ? undefined : json['isBlocked'],
        'jNr': json['jNr'] == null ? undefined : json['jNr'],
    };
}

export function PartnerSearchByBrResponseToJSON(json: any): PartnerSearchByBrResponse {
    return PartnerSearchByBrResponseToJSONTyped(json, false);
}

export function PartnerSearchByBrResponseToJSONTyped(value?: PartnerSearchByBrResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'globalPartnerId': value['globalPartnerId'],
        'techId': value['techId'],
        'partnerType': value['partnerType'],
        'imported': value['imported'],
        'mainDomicileCountry': value['mainDomicileCountry'],
        'fullName': value['fullName'],
        'dateOfOrigin': value['dateOfOrigin'] == null ? value['dateOfOrigin'] : value['dateOfOrigin'].toISOString().substring(0,10),
        'lastLogin': value['lastLogin'] == null ? value['lastLogin'] : value['lastLogin'].toISOString(),
        'isBlocked': value['isBlocked'],
        'jNr': value['jNr'],
    };
}

